import cn from "@utils/cn";

const CLASS_NAMES = cn(`
  flex
  items-center
  justify-start
  h-navbar-height
  gap-2
  px-4
  text-base
  font-medium
  tracking-wide
  outline-hidden
  cursor-pointer
  select-none
  transition-all
  duration-200

  text-white
  ring-0

  hover:bg-(--navbar-menu-hover-background-color)
  hover:[--icon-background-color:var(--navbar-menu-hover-background-color)]

  focus:bg-(--navbar-menu-focus-background-color)
  focus:[--icon-background-color:var(--navbar-menu-focus-background-color)]
  focus:ring-0
  focus:outline-hidden

  active:bg-(--navbar-menu-focus-background-color)
  active:[--icon-background-color:var(--navbar-menu-focus-background-color)]
  active:ring-0
  active:outline-hidden

  data-[selected=true]:bg-(--navbar-menu-active-background-color)
  data-[selected=true]:text-white
  data-[selected=true]:[--icon-background-color:var(--navbar-menu-active-background-color)]
`);

export default function NavbarBaseSlot(props) {
  const {
    className,
    onClick,
    tooltip,
  } = props;

  const classNames = cn(CLASS_NAMES, className);

  return (
    <div
      className={classNames}
      onClick={onClick}
      data-tooltip-id="app-tooltip"
      data-tooltip-content={tooltip}
    >
      {props.children}
    </div>
  );
}
